import { Link } from "react-router-dom";

import { LogoIcon } from "components/Icons";

import { AQA_LINK_HEADER } from "./AqaIds";
import HelpBar from "./HelpBar/HelpBar";

import styles from "./MainSidebar.module.scss";

export const MainSidebarGuest = () => {
  return (
    <div
      className={styles.root}
      data-testid="sidebar-guest"
    >
      <div className={styles.sidebarHead}>
        <Link
          key="app_header"
          to="/"
          data-testid={AQA_LINK_HEADER}
          className={styles.logo}
        >
          <LogoIcon />
        </Link>
      </div>
      <div className={styles.sidebarFooter}>
        <HelpBar />
      </div>
    </div>
  );
};
